import { render, staticRenderFns } from "./dictPicker.vue?vue&type=template&id=736501b6&scoped=true"
import script from "./dictPicker.vue?vue&type=script&lang=js"
export * from "./dictPicker.vue?vue&type=script&lang=js"
import style0 from "./dictPicker.vue?vue&type=style&index=0&id=736501b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736501b6",
  null
  
)

export default component.exports